import React from 'react'
import ServiceAccount from '@components/LocalMerchant/ServiceAccount'
import { getRouteComponent } from '@util'
import store from '@components/LocalMerchant/ServiceAccount/store'
import JiaMengHeader from '@components/JiaMeng/Header/Setting'
import { PRIVILEGE_NORMAL_ID, PRIVILEGE_STORE_ID } from '@constant'

export default {
  path: 'serviceAccount',
  component: props => <JiaMengHeader key="serviceAccount" {...props} />,
  indexRoute: {
    getComponent: getRouteComponent(ServiceAccount, {
      role: [PRIVILEGE_NORMAL_ID, PRIVILEGE_STORE_ID]
    }),
    onEnter(nextState, replace) {
      store.resetStatus()
    }
  },
  stat: '客服账号管理/首页'
}
